import type React from 'react';

import * as st from './styles.module.scss';

export const MoveButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = ({
	...props
}) => {
	return (
		<button className={st.assign} {...props}>
			Перенести
		</button>
	);
};
